module.exports = __webpack_public_path__ + "static/img/cara-002.c15610a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cara-002.svg
// module id = siLW
// module chunks = 1